import { Close } from "@mui/icons-material";
import { Box, Divider, Drawer, IconButton, Stack, Typography } from "@mui/material";
import { Dispatch, ReactNode, SetStateAction } from "react";

type props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  anchor?: "left" | "right" | "top" | "bottom";
  width?: number | string;
  title?: string;
  children?: ReactNode;
  allowCloseIcon?: boolean;
};

export default function SimpleDrawer({
  open,
  setOpen,
  anchor = "right",
  width = 320,
  title,
  children,
  allowCloseIcon = true
}: props) {
  return (
    <Drawer anchor={anchor} open={open} onClose={() => setOpen(false)}>
      <Box sx={{ width, p: 2, display: "flex", flexDirection: "column", height: "100%" }}>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <Typography variant="h6">{title}</Typography>
          {allowCloseIcon && (
            <IconButton onClick={() => setOpen(false)} aria-label="Close drawer">
              <Close />
            </IconButton>
          )}
        </Stack>
        <Divider sx={{ my: 1 }} />
        <Box sx={{ flex: 1, overflow: "auto" }}>{children}</Box>
      </Box>
    </Drawer>
  );
}
